// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1a3efa9e","239":"144f3efa","455":"1ccb4a20"}[chunkId] + ".chunk.js";
};